import { Component, OnInit, Inject, SecurityContext } from '@angular/core';
import { MAT_DIALOG_DATA} from '@angular/material'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-historia-clinica',
  templateUrl: './historia-clinica.component.html',
  styleUrls: ['./historia-clinica.component.scss']
})
export class HistoriaClinicaComponent implements OnInit {
  public consecutivo;
  public reqreg;
  public doc_benef;
  public url;
  //public urlPdf:SafeUrl;
  constructor(@Inject(MAT_DIALOG_DATA) public data, public sanitizier:DomSanitizer) {
    if(this.data.tipo == 'HC_Beneficiario'){
      this.doc_benef = this.data.bendoc;
    }else{
      this.consecutivo = this.data.consecutivo;
      this.reqreg = this.data.reqreg;
    }
  }

  ngOnInit() {
    /*Prueba
    this.urlPdf = this.sanitizier.bypassSecurityTrustUrl("http://redmedicavital.com/vhce/consulta_hc/?consecutivo_get=" + this.consecutivo);
    console.log(this.urlPdf)
    */
    if(this.reqreg == 0){
      this.url = "http://190.128.118.236:83/consulta_hc/HCAnalogas/"+this.consecutivo+".pdf";
    }else if(this.doc_benef){
      this.url = "http://redmedicavital.com/vhce/consulta_hc/?documento="+this.doc_benef;
    }else{
      this.url = "http://redmedicavital.com/vhce/consulta_hc/?consecutivo_get=" + this.consecutivo;
    }
  }

  public getSantizeUrl(url: string) {
    return this.sanitizier.bypassSecurityTrustUrl(url);
  }

}
